const KERNEL_TENANT_HEADER = 'vendure-token';
const KERNEL_AUTH_RESPONSE_HEADER = 'vendure-auth-token';
const STOREFRONT_TENANT_HEADER = 'x-store-key';
export const TALI_IMPERSONATION_READY = 'tali:impersonation-ready';
export const TALI_IMPERSONATION_SESSION = 'tali:impersonation-session';
export function resolveTaliViteApiEndpoints(environment, defaultAdminUrl) {
    const taliAdminUrl = environment.VITE_TALI_API_URL;
    const legacyKernelUrl = environment.VITE_VENDURE_API_URL;
    return resolveTaliApiEndpoints({
        ...(typeof taliAdminUrl === 'string' ? { taliAdminUrl } : {}),
        ...(typeof legacyKernelUrl === 'string' ? { legacyKernelUrl } : {}),
        defaultAdminUrl,
    });
}
function replaceSurface(url, surface) {
    const target = surface === 'admin' ? '/admin-api' : '/shop-api';
    if (/\/(admin|shop)-api\/?$/.test(url)) {
        return url.replace(/\/(admin|shop)-api\/?$/, target);
    }
    return `${url.replace(/\/$/, '')}${target}`;
}
export function resolveTaliApiEndpoints(options) {
    const primary = options.taliAdminUrl || options.legacyKernelUrl || options.defaultAdminUrl;
    const admin = replaceSurface(primary, 'admin');
    const shop = options.taliShopUrl
        ? replaceSurface(options.taliShopUrl, 'shop')
        : replaceSurface(primary, 'shop');
    const base = admin.replace(/\/admin-api\/?$/, '');
    return { admin, shop, base };
}
/** Build headers for TALI merchant/platform API calls. Kernel details stay inside the SDK. */
export function buildTaliAdminHeaders(options = {}) {
    const headers = {};
    if (options.contentType)
        headers['Content-Type'] = options.contentType;
    if (options.accessToken)
        headers.Authorization = `Bearer ${options.accessToken}`;
    if (options.tenantToken)
        headers[KERNEL_TENANT_HEADER] = options.tenantToken;
    return headers;
}
/** Build headers for public TALI storefront calls. */
export function buildTaliShopHeaders(options = {}) {
    const headers = {};
    if (options.contentType)
        headers['Content-Type'] = options.contentType;
    if (options.accessToken)
        headers.Authorization = `Bearer ${options.accessToken}`;
    if (options.tenantToken)
        headers[STOREFRONT_TENANT_HEADER] = options.tenantToken;
    return headers;
}
/** Read a commerce-kernel session response without leaking its header name to product apps. */
export function readTaliAuthToken(headers) {
    return headers.get(KERNEL_AUTH_RESPONSE_HEADER);
}
export function readTaliAdminTenantToken(headers) {
    return headers.get(KERNEL_TENANT_HEADER);
}
export function resolveTaliImpersonationOrigin(configuredPlatformUrl, referrer) {
    const candidate = configuredPlatformUrl || referrer;
    if (!candidate)
        return null;
    try {
        return new URL(candidate).origin;
    }
    catch {
        return null;
    }
}
export function isTaliImpersonationReady(event, expectedSource, expectedOrigin) {
    return event.source === expectedSource
        && event.origin === expectedOrigin
        && isRecord(event.data)
        && event.data.type === TALI_IMPERSONATION_READY;
}
export function readTaliImpersonationSession(event, expectedSource, expectedOrigin) {
    if (event.source !== expectedSource
        || event.origin !== expectedOrigin
        || !isRecord(event.data)
        || event.data.type !== TALI_IMPERSONATION_SESSION
        || typeof event.data.tenantToken !== 'string'
        || event.data.tenantToken.trim().length === 0) {
        return null;
    }
    return {
        tenantToken: event.data.tenantToken,
        ...(typeof event.data.storeName === 'string' ? { storeName: event.data.storeName } : {}),
    };
}
function isRecord(value) {
    return typeof value === 'object' && value !== null;
}
//# sourceMappingURL=http.js.map